import { Link, useLocation } from "react-router-dom";
import { Home, UserPlus, CircleHelp } from "lucide-react";
import "./BottomNav.css";
import { getLocaleFromPathname, withLocale } from "../utils/locale";

function BottomNav() {
  const location = useLocation();
  const locale = getLocaleFromPathname(location.pathname);
  const copy =
    locale === "vi"
      ? {
          home: "Bảng tin",
          addServer: "Thêm server",
          profile: "Hồ sơ",
        }
      : {
          home: "피드",
          addServer: "서버추가",
          profile: "프로필",
        };

  const tabs = [
    { name: copy.home, icon: <Home size={20} />, path: withLocale("/", locale) },
    { name: copy.addServer, icon: <UserPlus size={20} />, path: withLocale("/profile", locale) },
    { name: copy.profile, icon: <CircleHelp size={20} />, path: withLocale("/design", locale) },
  ];

  return (
    <>
      <div className="bottom-nav">
        {tabs.map((tab) => (
          <Link key={tab.path} to={tab.path} className={location.pathname === tab.path ? "active" : ""}>
            {tab.icon}
            <span>{tab.name}</span>
          </Link>
        ))}
      </div>

      <div className="bottom-nav-spacer"></div>
    </>
  );
}

export default BottomNav;
